module.exports = __webpack_public_path__ + "img/bdo_logo.f77770ac.jpg";